import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import {
  Card,
  CardMedia,
  CardContent,
  Typography,
  Box,
  Button,
} from "@mui/material";
import { WhatsApp, Call } from "@mui/icons-material";
import "./CarCard.css";

const CarCard = ({ car }) => {
  const [shopeDetails, setShopeDetails] = useState([]);

  useEffect(() => {
    fetch("/assets/carData/shopDetails.json")
      .then((res) => res.json())
      .then((data) => setShopeDetails(data))
      .catch((err) => console.error("Failed to fetch shop data", err));
  }, []);
  return (
    // inside return
    <Link to={`/car-details/${car.id}`} style={{ textDecoration: "none" }}>
      <Card className="car-card">
        <CardMedia
          component="img"
          height="180"
          image={
            car.image.startsWith("http")
              ? car.image
              : `/assets/carImages/${car.image}`
          }
          alt={car.name}
          className="car-card-media"
        />
        <Box className="car-card-actions">
          <Button
            className="car-card-button whatsapp"
            aria-label="Contact via WhatsApp"
            onClick={() => {
              const message = `Hi, I'm interested in the ${car.name} (${car.year}, ${car.fuel}, ${car.transmission}, ₹${car.price}L). 
Here's the link: ${window.location.origin}/car-details/${car.id}
Could you please share more details?`;

              const phoneNumber = shopeDetails[0].whatsapp; // e.g., 919876543210
              const whatsappURL = `https://wa.me/${phoneNumber}?text=${encodeURIComponent(
                message
              )}`;

              window.open(whatsappURL, "_blank");
            }}
          >
            <img src="/assets/icon/whatsappSVG.svg" alt="WhatsApp" width={25} />
          </Button>

          <Button
            className="car-card-button call"
            aria-label="Call now"
            onClick={() => {
              window.location.href = "tel:" + shopeDetails[0].phone; // Replace with your phone number
            }}
          >
            <img src="/assets/icon/call-supportSVG.svg" alt="Call" width={25} />
          </Button>
        </Box>
        <CardContent>
          <Typography variant="h6" gutterBottom className="car-card-title">
            {car.name}
          </Typography>
          <Box className="car-card-details" xs={6} sm={6}>
            <Box className="car-card-detail-item">
              <img
                src={`/assets/icon/${
                  car.transmission === "Automatic" ? "steering" : "transmission"
                }.svg`}
                alt={
                  car.transmission === "Automatic"
                    ? "Automatic Transmission"
                    : "Manual Transmission"
                }
                className="car-card-icon"
              />
              <Typography variant="body2">{car.transmission}</Typography>
            </Box>

            <Box className="car-card-detail-item">
              <img
                src="/assets/icon/fuel.svg"
                alt="Fuel Type"
                className="car-card-icon"
              />
              <Typography variant="body2">{car.fuel}</Typography>
            </Box>
          </Box>
          <Box className="car-card-details car-card-stats" xs={6} sm={6}>
            <Box className="car-card-detail-item">
              <img
                src="/assets/icon/road.svg"
                alt="Mileage"
                className="car-card-icon"
              />
              <Typography variant="body2">{car.mileage} km</Typography>
            </Box>
            <Box className="car-card-detail-item">
              <img
                src="/assets/icon/calender.svg"
                alt="Year"
                className="car-card-icon"
              />
              <Typography variant="body2">{car.year}</Typography>
            </Box>
          </Box>

          <Box
            sx={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
              flexDirection: { xs: "row", sm: "row" }, // Stacks on mobile, row on larger screens
            }}
          >
            <Box className="car-card-details-price">
              <Typography variant="h6" className="car-card-price">
                {car.price.toLocaleString("en-IN", {
                  style: "currency",
                  currency: "INR",
                  minimumFractionDigits: 0,
                  maximumFractionDigits: 0,
                })}
              </Typography>
            </Box>
            <Box className="car-card-details-button-container">
              <Button
                variant="contained"
                className="car-card-details-button"
                onClick={() =>
                  (window.location.href = `/car-details/${car.id}`)
                }
              >
                Details
              </Button>
            </Box>
          </Box>
        </CardContent>
      </Card>
    </Link>
  );
};

export default CarCard;
